/* eslint-disable id-blacklist */
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { ColumnType } from 'app/shared/utils/column-type.util';
import { preCopyScriptMetadata } from '../consts/metadata-consts';

export const databricksDatasetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.databricks.datasetType,
    supportLinkedServiceTypes: [adfModelTypeMap.databricks.linkedServiceType],
    displayName: stringResources.Activity_Category_Databricks,
    datasetKind: 'table',
    isSource: true,
    isSink: true,
    icon: {
        className: 'svg-i-20x20-delta-lake'
    },
    isFirstClass: true,
    notSupportTypeConversion: true,
    supportTypeConversionWhenStaging: __IS_FABRIC_DPE__,
    useExternalCommandWhenSource: true,
    notSupportAdditionalColumns: __IS_FABRIC_DPE__,
    supportCreatedAsV2: true,
    splitTablePath: true,
    separatedSchemaTableSelection: true,
    displayHierarchicalSchema: true,
    schemaNameDisplay: stringResources.Database,
    databaseDisplayName: stringResources.ModelName_Catalog,
    databaseAlias: 'catalog',
    schemaAlias: 'database',
    category: ['Database'],
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'dateFormat',
                label: stringResources.DateFormat_Label,
                isLabelVertical: false
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'timestampFormat',
                label: stringResources.Timestamp_Format_Label,
                isLabelVertical: false
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    copySinkControls: [
        preCopyScriptMetadata(),
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'timestampFormat',
                label: stringResources.Timestamp_Format_Label,
                isLabelVertical: false
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    lookupSourceControls: [],
    PhysicalToLogicalMapping: {
        long: ColumnType.Int64,
        integer: ColumnType.Int32,
        short: ColumnType.Int16,
        byte: ColumnType.SByte,
        float: ColumnType.Single,
        double: ColumnType.Double,
        decimal: ColumnType.Decimal,
        string: ColumnType.String,
        boolean: ColumnType.Boolean,
        date: ColumnType.Date,
        timestamp: ColumnType.DateTime
    }
};
